<template>
    <expandable-panel
        v-if="hasBookmarks"
        :expand="expand"
        :id="`notes-expansion-panel-wrapper-${sectionId}`"
        class="notes-expansion-panel-wrapper"
        outlined
    >
        <template v-slot:title>
            <div style="display: inline">
        <span class="text--secondary font-weight-bold">
          NOTES ({{ bookmarksCount }})
        </span>
            </div>
        </template>

        <template v-slot:content>
            <v-card
                v-for="item in localBookmarks"
                :key="item.id"
                :id="'bookmark-list-item-' + item.id"
                flat
            >
                <v-card-text class="pa-0 notes-bookmarks-section">
                    <note-list-item
                        :type="bookmarkType(item)"
                        :data="item"
                        :tags="tags"
                    />
                </v-card-text>
            </v-card>
        </template>
    </expandable-panel>
</template>

<script>
import ExpandablePanel from "../titles/partials/ExpandablePanel.vue";
import NoteListItem from "../titles/partials/noteListItem.vue";

export default {
    name: "ContentSectionUserBookmarks",
    props: {
        bookmarks: {
            type: Array,
            required: true
        },
        tags: {
            type: Array,
            required: true
        },
        sectionId: {
            type: Number,
            default: null
        },
        expandSection: {
            type: Boolean,
            default: false
        }
    },
    components: { NoteListItem, ExpandablePanel },
    data() {
        return {
            expand: this.expandSection,
            localBookmarks: [...this.bookmarks]
        };
    },
    watch: {
        bookmarks(newVal) {
            this.localBookmarks = [...newVal];
        }
    },
    computed: {
        hasBookmarks() {
            return this.localBookmarks.length > 0;
        },
        bookmarksCount() {
            return this.localBookmarks.length;
        }
    },
    methods: {
        openNoteModal() {
            this.$emit("open-note-modal", { sectionId: this.sectionId });
        },
        updateBookmarks(newItems) {
            newItems.forEach(newItem => {
                const idx = this.localBookmarks.findIndex(b => b.id === newItem.id);
                if (idx !== -1) {
                    this.$set(this.localBookmarks, idx, newItem);
                } else {
                    this.localBookmarks.push(newItem);
                }
            });
        },
        deleteBookmark(id) {
            this.localBookmarks = this.localBookmarks.filter(item => item.id !== id);
        },
        bookmarkType(item) {
            return item.annotation ? "note" : "bookmark";
        }
    },
    created() {
        EventBus.listen("update-notes", data => {
            if (data.sectionId === this.sectionId) {
                switch (data.action) {
                    case "create":
                    case "update":
                        const {
                            bookmarks = [],
                            annotations = []
                        } = data.notes || {};

                        this.updateBookmarks([
                            ...bookmarks,
                            ...annotations
                        ]);
                        break;
                    case "remove":
                        this.deleteBookmark(data.id);
                        break;
                }
            }
        });
    }
};
</script>

<style scoped lang="scss">
.notes-bookmarks-wrapper {
    .v-expansion-panel:before {
        box-shadow: unset !important;
    }
    .v-expansion-panel-content__wrap {
        padding: 0;
    }
    .v-expansion-panel-header {
        padding-left: 0 !important;
        padding-right: 0 !important;
        min-height: 40px;
    }
}
</style>